module.exports = __webpack_public_path__ + "static/fear-and-loathing-in-las-vegas-harper-perennial-modern-classics-b467ce939c3cba86bf60c27bba282912.jpg";